// Code review - In Progress
// Documentation - In Progress
import React from 'react';

const Loader = ({ isVisible, size = 'h-16 w-16', color = 'border-t-blue-500', backgroundColor = 'bg-gray-800', blur = true }) => {
  if (!isVisible) return null; // If not visible, return null (don't render anything)

  const blurClass = blur ? 'backdrop-blur-md' : ''; // Optional blur effect class

  return (
    <div className={`absolute inset-0 ${backgroundColor} opacity-50 flex justify-center items-center z-50 ${blurClass}`}>
      <div className={`animate-spin ${size} border-4 ${color} border-solid rounded-full`}></div>
    </div>
  );
};

export default Loader;
